import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getBasicAutomation } from 'modules/settings/api';

export const useQueryBasicAutomations = () => {
  const {
    data: basicAutomations,
    isLoading: isLoadingBasicAutomations,
    isError: isErrorBasicAutomations,
  } = useQuery([QUERY_KEYS.SETTINGS_BASIC_AUTOMATION], getBasicAutomation, {
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return { basicAutomations, isLoadingBasicAutomations, isErrorBasicAutomations };
};
